/*
 * Public API Surface of xliffmerge
 */

export * from './lib/xliffmerge.module';
export {
  IXliffMergeOptions,
  IConfigFile,
  ProgramOptions,
} from './xliffmerge/i-xliff-merge-options';
export { WriterToString } from './common/writer-to-string';
export { CommandOutput } from './common/command-output';
export { XliffMerge } from './xliffmerge/xliff-merge';
